import React, { Component } from 'react';
import ReactCursorPosition from 'react-cursor-position';
import ReactPlayer from 'react-player'
import { isMobile } from 'react-device-detect';
import './css/Video.css';


class Video extends Component {
    constructor(props) {
        super(props);
        this.state = {
            playing: true, 
            muted: true,
            isEnd: false,
            windowHeight: window.innerHeight,
            windowWidth: window.innerWidth
        }; 
        
        this.playPause = this.playPause.bind(this);
        this.toggleMuted = this.toggleMuted.bind(this);
        this.updateWindowHeight = this.updateWindowHeight.bind(this);
        window.addEventListener("resize", this.updateWindowHeight);
    }

    componentDidMount = () => {
        if(!isMobile){
            if(document.getElementsByClassName('carousel-status')[0] !== null || document.getElementsByClassName('carousel-status')[0] !== undefined) {
                document.getElementsByClassName('carousel-status')[0].style.display = "none"
                setTimeout(function(){
                    document.getElementsByClassName('carousel-status')[0].style.display = "block"
                }, 500);
            }
        }
    }

    toggleMuted(){
        this.setState({ 
            muted: !this.state.muted 
        })
    }

    playPause() {
        this.setState({ 
            playing: !this.state.playing 
        })
     }

    //WINDOW HEIGHT 
    updateWindowHeight() {
        this.setState({ windowHeight: window.innerHeight, windowWidth:window.innerWidth });
    }

    render() {

        return (  
            <div className="gallery">
                <ReactCursorPosition>
                    <div className="gallery-inner">
                        <div className="video-player">
                            <div className="player-wrapper">
                                <ReactPlayer 
                                    className='react-player'
                                    url={this.props.video.fields.file.url} 
                                    playing={this.state.playing} 
                                    playsinline={true}
                                    muted={this.state.muted}
                                    volume={1}
                                    width='100%'
                                    height='100%'
                                />
                            </div>
                        </div>
                    </div>                  
                   <PositionLabel title={this.props.postName} /> 
                   <div className="videoControls">
                        <div id="play" className='videoControl menuTriggerInner' onClick={this.playPause}>{this.state.playing ? "Pause" : "Play"}</div>
                        {/* <div id="pause" className="videoControl menuTriggerInner">Pause</div> */}
                        {/* <div id="pause" className="videoControl menuTriggerInner">Stop</div> */}
                        <div id="pause" className="videoControl menuTriggerInner" onClick={this.toggleMuted}>{this.state.muted ? "Sound On" : "Sound Off"}</div>
                   </div>
                 </ReactCursorPosition>
                 <div id="postCategory">{this.props.postCat}</div>
            </div>
        )
      }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowHeight);        
    }
}

export default Video;

const PositionLabel = (props, data) => {
    const {
      position: {
        x = window.innerWidth / 2,
        y = window.innerHeight / 2,
      } = {}
    } = props;
    return (
      <div className="carousel-status" style={{top:y+10, left:x+10}}>
        <h2 className="title">{props.title}</h2>
      </div>
    );
};




// WEBPACK FOOTER //
// ./src/Video.js